import React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

export default function TopTabButton({ setToptab, toptab }) {
  // Define the handleChange function
  const handleChange = (event, newValue) => {
    setToptab(newValue);
  };

  return (
    <div className="d-flex p-2 mb-3 justify-content-center">
      <Tabs
        value={toptab}
        onChange={handleChange}
        aria-label="nav tabs example"
        role="navigation"
        sx={{
          backgroundColor: 'transparent', // Dark background for tabs
          borderRadius: '8px',
        }}
        textColor="inherit" // Inherit color for custom styling
        TabIndicatorProps={{
          style: {
            backgroundColor: '#17b785', // Tab indicator color
          },
        }}
      >
        {/* Define the individual Tab components */}
        <Tab
          label="Current Week Winner"
          
          sx={{
            color: toptab === 0 ? '#17b785' : '#fff', // Active tab color, inactive tab color
            '&.Mui-selected': {
              color: '#17b785', // Selected tab text color
            },
            '&:hover': {
              color: '#17b785', // Hover color
            },
          }}
        />
        <Tab
          label="Last Week Winner"
          sx={{
            color: toptab === 1 ? '#17b785' : '#fff', // Active tab color, inactive tab color
            '&.Mui-selected': {
              color: '#17b785', // Selected tab text color
            },
            '&:hover': {
              color: '#17b785', // Hover color
            },
          }}
        />
      </Tabs>
      
    </div>
  );
}
